import { combineReducers } from 'redux';

import calendar from './calendar/reducer';
import contest from './contest/reducer';
import dressageProtocol from './dressage/reducer';
import dressageProtocols from './dressagelist/reducer';

const rootReducer = combineReducers({
  calendar,
  contest,
  dressageProtocol,
  dressageProtocols
});


export default rootReducer;
